export default "__VITE_ASSET__CWltB9xV__"